import { Trans } from '@lingui/macro'
import Button from '@mui/material/Button'
import LoadingButton from '@mui/lab/LoadingButton'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1'
import PersonSearchIcon from '@mui/icons-material/PersonSearch'
import LocalHospitalIcon from '@mui/icons-material/LocalHospital'

import { ReceptionStep } from '../model/useSimplifiedReception'

type ActionChoiceProps = { onChoose: (step: ReceptionStep) => void; onEmergency: () => void; isCreatingEmergency?: boolean }

const actionSx = { justifyContent: 'flex-start', py: 3, px: 4, textAlign: 'left', gap: 2, '& svg': { fontSize: 40 } }

/** The three things a person in simplified reception mode can do. */
export function ActionChoice({ onChoose, onEmergency, isCreatingEmergency }: ActionChoiceProps) {
  return (
    <Stack spacing={3}>
      <Button variant="contained" size="large" sx={actionSx} onClick={() => onChoose('new-patient')} startIcon={<PersonAddAlt1Icon />}>
        <Stack>
          <Typography variant="h5" color="inherit"><Trans>New patient</Trans></Typography>
          <Typography variant="body2" color="inherit"><Trans>Create the patient, then put them in a waiting room</Trans></Typography>
        </Stack>
      </Button>
      <Button variant="contained" size="large" sx={actionSx} onClick={() => onChoose('existing-patient')} startIcon={<PersonSearchIcon />}>
        <Stack>
          <Typography variant="h5" color="inherit"><Trans>Existing patient</Trans></Typography>
          <Typography variant="body2" color="inherit"><Trans>Find the patient, then put them in a waiting room</Trans></Typography>
        </Stack>
      </Button>
      <LoadingButton variant="contained" color="error" size="large" sx={actionSx} onClick={onEmergency} loading={isCreatingEmergency} loadingPosition="start" startIcon={<LocalHospitalIcon />}>
        <Stack>
          <Typography variant="h5" color="inherit"><Trans>Emergency patient</Trans></Typography>
          <Typography variant="body2" color="inherit"><Trans>Created in one click, identity to complete later, then a waiting room</Trans></Typography>
        </Stack>
      </LoadingButton>
    </Stack>
  )
}
